var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table offer-info", staticStyle: { "margin-top": "1em" } },
    [
      ["capacityAnalysis", "costBreakdown"].indexOf(_vm.type) >= 0
        ? _c(
            "el-row",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    "vertical-align": "middle",
                    display: "inline-block",
                  },
                },
                [
                  _vm.isSupplier
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.downloadTemplate()
                            },
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("ssrManage.supDownloadTemplate"))
                          ),
                        ]
                      )
                    : _vm._e(),
                  !_vm.isSupplier &&
                  _vm.c_files != null &&
                  _vm.c_files.length > 0
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.downloadAll(_vm.roundId)
                            },
                          },
                        },
                        [_vm._v("Download Attachments")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "uploadContainer",
                  staticStyle: {
                    "vertical-align": "middle",
                    display: "inline-block",
                    "margin-left": "10px",
                    "line-height": "0",
                  },
                },
                [
                  _vm.isSupplier && _vm.canEdit
                    ? _c(
                        "el-upload",
                        {
                          staticStyle: { display: "inline-block" },
                          attrs: {
                            headers: _vm.uploadHeader,
                            "show-file-list": false,
                            "http-request": _vm.updateTemplate,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                "vertical-align": "middle",
                                "padding-right": "10px",
                              },
                              attrs: { slot: "trigger", type: "primary" },
                              slot: "trigger",
                            },
                            [_vm._v("Upload")]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._l(_vm.c_files, function (file) {
                return _c(
                  "div",
                  { staticStyle: { display: "inline-block" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "1em" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.download(file)
                          },
                        },
                      },
                      [_vm._v(_vm._s(file.documentName))]
                    ),
                    _vm.isSupplier && _vm.canEdit
                      ? _c("el-button", {
                          attrs: {
                            type: "danger",
                            icon: "el-icon-delete",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.deleteFile(file)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _vm._e(),
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.c_data } },
        [
          _c(
            "el-table",
            {
              ref: "table",
              staticStyle: { "margin-top": "15px" },
              attrs: {
                data: _vm.c_data,
                border: "",
                "highlight-current-row": "",
              },
            },
            [
              _vm.c_canEdit
                ? _c("el-table-column", { attrs: { type: "selection" } })
                : _vm._e(),
              _vm._l(_vm.c_template.columns, function (column, index) {
                return _vm.template.columns[index] != null
                  ? _c("el-table-column", {
                      attrs: {
                        "min-width":
                          50 +
                          (column.length * 20 < 100 ? 100 : column.length * 20),
                        "column-key": column,
                        label: column,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm.type == "capacityAnalysis" && index == 0
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "el-input el-input--small is-disabled",
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: `[${scope.$index}].data.columns[${index}]`,
                                              rules: _vm.requiredRule,
                                            },
                                          },
                                          [
                                            _c("input", {
                                              staticClass: "el-input__inner",
                                              attrs: { disabled: "" },
                                              domProps: {
                                                value:
                                                  scope.row.data.columns[index],
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.type == "capacityAnalysis" &&
                                    index == 1 &&
                                    _vm.c_canEdit
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: `[${scope.$index}].data.columns[${index}]`,
                                              rules: _vm.requiredRule,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  disabled: !_vm.c_canEdit,
                                                },
                                                model: {
                                                  value:
                                                    scope.row.data.columns[
                                                      index
                                                    ],
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row.data.columns,
                                                      index,
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.data.columns[index]",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: "Please select",
                                                    value: "",
                                                  },
                                                }),
                                                _vm._l(
                                                  _vm.myPlants,
                                                  function (plant) {
                                                    return _c("el-option", {
                                                      key: plant.tmSupplierId,
                                                      attrs: {
                                                        label:
                                                          plant.supplierName,
                                                        value:
                                                          plant.supplierName,
                                                      },
                                                    })
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.type == "costBreakdown" &&
                                    (index == 0 || index == 2)
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "el-input el-input--small",
                                        class: _vm.c_canEdit
                                          ? ""
                                          : "is-disabled",
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: `[${scope.$index}].data.columns[${index}]`,
                                              rules: _vm.requiredRule,
                                            },
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    scope.row.data.columns[
                                                      index
                                                    ],
                                                  expression:
                                                    "scope.row.data.columns[index]",
                                                },
                                              ],
                                              staticClass: "el-input__inner",
                                              attrs: {
                                                disabled: !_vm.c_canEdit,
                                              },
                                              domProps: {
                                                value:
                                                  scope.row.data.columns[index],
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    scope.row.data.columns,
                                                    index,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.type == "costBreakdown" && index == 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "el-input el-input--small",
                                        class: _vm.c_canEdit
                                          ? ""
                                          : "is-disabled",
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: `[${scope.$index}].data.columns[${index}]`,
                                            },
                                          },
                                          [
                                            _c("MaterialInput", {
                                              attrs: {
                                                disabled: !_vm.c_canEdit,
                                              },
                                              on: {
                                                pick: function ($event) {
                                                  return _vm.changeMaterial(
                                                    $event,
                                                    scope.row
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  scope.row.data.columns[index],
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    scope.row.data.columns,
                                                    index,
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.data.columns[index]",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.type == "costBreakdown" &&
                                    index == _vm.totalColIndex
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "el-input el-input--small",
                                        class: _vm.c_canEdit
                                          ? ""
                                          : "is-disabled",
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: `[${scope.$index}].data.columns[${index}]`,
                                              rules: _vm.requiredRule,
                                            },
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    scope.row.data.columns[
                                                      index
                                                    ],
                                                  expression:
                                                    "scope.row.data.columns[index]",
                                                },
                                              ],
                                              staticClass: "el-input__inner",
                                              attrs: {
                                                disabled: !_vm.c_canEdit,
                                              },
                                              domProps: {
                                                value:
                                                  scope.row.data.columns[index],
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    scope.row.data.columns,
                                                    index,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "el-input el-input--small",
                                        class: _vm.c_canEdit
                                          ? ""
                                          : "is-disabled",
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              prop: `[${scope.$index}].data.columns[${index}]`,
                                              rules:
                                                _vm.commonColumnRules(index),
                                            },
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    scope.row.data.columns[
                                                      index
                                                    ],
                                                  expression:
                                                    "scope.row.data.columns[index]",
                                                },
                                              ],
                                              staticClass: "el-input__inner",
                                              style: _vm.capacityStyle(
                                                index,
                                                scope.row.data.columns[index]
                                              ),
                                              attrs: {
                                                disabled: !_vm.c_canEdit,
                                              },
                                              domProps: {
                                                value:
                                                  scope.row.data.columns[index],
                                              },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.costBreakdownChange(
                                                    scope.$index
                                                  )
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    scope.row.data.columns,
                                                    index,
                                                    $event.target.value
                                                  )
                                                },
                                              },
                                            }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e()
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }